import { render, staticRenderFns } from "./approveModal.vue?vue&type=template&id=63ca2b61&"
import script from "./approveModal.vue?vue&type=script&lang=js&"
export * from "./approveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports